import { Slot } from './interface';

export const getCompleteData = async (
  params?: Record<string, any>,
  headers?: HeadersInit,
) => {
  const queryParams = new URLSearchParams({
    action: 'content',
    ...params,
  }).toString();
  const url = `/api/app-wrapper?${queryParams}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.errorMessage || 'Failed to fetch content',
      raw: errorData,
    };
  }

  return response.json();
};

export const getSlots = async (
  params?: Record<string, any>,
): Promise<Slot[]> => {
  const queryParams = new URLSearchParams({
    action: 'slots',
    ...params,
  }).toString();
  const url = `/api/app-wrapper?${queryParams}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.errorMessage || 'Failed to fetch slots',
      raw: errorData,
    };
  }

  return response.json();
};

export const makeReservation = async (
  payload: any,
  params?: Record<string, any>,
  headers?: HeadersInit,
) => {
  const response = await fetch('/api/app-wrapper', {
    method: 'POST',
    body: JSON.stringify({
      ...payload,
      queryParams: params,
    }),
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.errorMessage || 'Failed to create reservation',
      raw: errorData,
    };
  }

  return response.json();
};

export const claimAntavoReward = async (
  payload: { userId: string; resourceId: string },
  headers?: HeadersInit,
) => {
  const response = await fetch('/api/app-wrapper', {
    method: 'POST',
    body: JSON.stringify({ action: 'antavoClaim', ...payload }),
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.errorMessage || 'Failed to claim offer',
      raw: errorData,
    };
  }

  return response.json();
};

